import dayjs from "dayjs";
import * as yup from "yup";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  seller: null,
  buyer: null,
  buyerableType: null,
  warehouse: null,
  note: "",
  customerClaimProductVariants: [],
};

export const VALIDATION_SCHEMA = yup.object().shape({
  transactionDate: yup.date().required("Tanggal transaksi harus diisi"),
  seller: yup.object().required("Outlet harus diisi").nullable(),
  buyer: yup.object().required("Pelanggan harus diisi").nullable(),
  buyerableType: yup.string().required("Jenis pembeli harus diisi"),
  warehouse: yup.object().required("Gudang harus diisi").nullable(),
  note: yup.string(),
  customerClaimProductVariants: yup
    .array()
    .test(
      "at-least-one-selected",
      "Minimal 1 barang harus dipilih",
      (variants) => variants && variants.some((v) => v.selected)
    ),
});
